import { UserIdSchema } from "../id"
import { Tagged } from "../lib/tag"
import { z } from "zod/v4"


export type FCMToken = Tagged<"FCMToken", string>
export type FCMTopic = Tagged<"FCMTopic", string>

export const FCMOwnershipDoc = z.object({
  owner: UserIdSchema,
})

export type FCMOwnershipDoc = z.infer<typeof FCMOwnershipDoc>

export const FCMSubscriptionDoc = z.object({
  token: z.string().transform(x => x as FCMToken), // same as id
  enabled: z.boolean(),
  pending: z.boolean(),
  retry_count: z.number().optional(),
  retry_after: z.number().optional(),
})

export type FCMSubscriptionDoc = z.infer<typeof FCMSubscriptionDoc>

export const FCMRecipientDoc = z.object({
  topics: z.array(z.string().transform(x => x as FCMTopic)).max(2000),
})

export type FCMRecipientDoc = z.infer<typeof FCMRecipientDoc>
